import type { CollectionCompany } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { useCollectionCompanies } from '@/hooks/api/use-collection-company'

interface CollectionCompaniesLoaderProps {
    children: (data: Array<CollectionCompany> ) => React.ReactNode
    privateList?: boolean
}

const CollectionCompaniesLoader: React.FC<CollectionCompaniesLoaderProps> = ({
    children,
}) => {

    const { status, data, error } = useCollectionCompanies()

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst svozové společnosti'}
        />
    }


    if (data.length > 0) {
        return <>{children(data)}</>
    }

    return null
}

export default CollectionCompaniesLoader
